import { createDeviceCipher } from "./e2e-crypto";

/**
 * Step 4 end-to-end encryption (Step 4 PRD §5; AUTHORIZATION_SPEC §Step 4).
 *
 * The mechanics live in e2e-crypto.ts, shared with Step 8. This module only
 * pins Step 4's own device key, so the two lists stay independent: Step 4's
 * writing is meant to be read aloud once (Step 5) and then deleted, while
 * Step 8's list has to survive into Step 9.
 *
 * The storage key below is load-bearing — changing it would orphan the
 * ciphertext already on people's devices.
 */
const step4Cipher = createDeviceCipher("happy24.step4.key");

/** True if a key already exists on this device (i.e. rows written here). */
export const hasStep4Key = step4Cipher.hasKey;
/** Encrypt a row's fields → opaque base64 (iv ‖ ciphertext). */
export const encryptRow = step4Cipher.encryptRow;
/** Decrypt a row, or null when this device doesn't hold the right key. */
export const decryptRow = step4Cipher.decryptRow;
